// Simple pub/sub for attendance refresh across components
const listeners = new Set();
export const onAttendanceRefresh = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const emitAttendanceRefresh = () => listeners.forEach(fn => fn());
